// Generated by ReScript, PLEASE EDIT WITH CARE


let basePathname = "auth";

let baseRoute = "/" + basePathname;

let loginRoute = baseRoute + "/login";

let loginSessionExpiredRoute = loginRoute + "/session-expired";

let loginImpersonationFailureRoute = loginRoute + "/impersonation-failure";

let loginRecoverySuccessRoute = loginRoute + "/password-reset";

let loginUsernameUpdateSuccessRoute = loginRoute + "/username-updated";

let logoutRoute = baseRoute + "/logout";

let logoutSessionExpiredRoute = logoutRoute + "/session-expired";

let logoutImpersonationFailureRoute = logoutRoute + "/impersonation-failure";

let recoveryRoute = baseRoute + "/recovery";

function resetRoute(token) {
  return baseRoute + "/reset/" + token;
}

function impersonationRoute(userId) {
  return baseRoute + "/impersonation/" + userId;
}

let loginRecoveryEmailSentRoute = loginRoute + "/recovery-email-sent";

let signupSuccess = baseRoute + "/signup/success";

export {
  basePathname,
  baseRoute,
  loginRoute,
  loginSessionExpiredRoute,
  loginImpersonationFailureRoute,
  loginRecoverySuccessRoute,
  loginUsernameUpdateSuccessRoute,
  logoutRoute,
  logoutSessionExpiredRoute,
  logoutImpersonationFailureRoute,
  recoveryRoute,
  resetRoute,
  impersonationRoute,
  loginRecoveryEmailSentRoute,
  signupSuccess,
}
/* No side effect */
